"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_pfeil_nordwest = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_pfeil_nordwest = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC9SURBVFhH7ZaxDcIwFAUNoWAExmAEygzAQGzACjBJoKNJkR6JkpKSEt5THAlZcXCAPFL8k07filKcbFmJMwzj30z8jLGFy3qZzB7u6uX3FPDR0w1MZurnaAl34A5zKKPtCKQRTcAF8mzlEa8BRB4RBhBpRFsAkUXEAogkoiuADB7xLoAMGpESQD6OyPyMwY9VBY/wxAcRDpDvruAMrmEJz1CK7HZ0YRENo4u4wjmUw4gb7Ptr91MWfhpGgHNPpfxmdLfNZXgAAAAASUVORK5CYII=",
    iconSize: [32, 32],
});
